module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "ChFront1"
  }, [_c('a', {
    attrs: {
      "id": "frontmatter01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common-right.jpg"
    }
  })])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NEARLY TWENTY YEARS AGO AN EDITOR AT A NEW YORK CITY")]), _vm._v(" publishing house suggested that I write a social history of American railroads. The idea appealed to me, and a contract and advance were forthcoming. Yet I could not rapidly deliver a manuscript, not because I had lost interest, but because I changed jobs, leaving the University of Akron to chair the Department of History at Clemson University.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the intervening years I continued to write articles, books, and essays on American railroad history, especially after I relinquished my administrative duties. In the process I gathered additional materials that dealt with what I saw as the four key components of a social history of railroads study: trains, stations, communities, and legacy. Indeed, I employed this basic structure to prepare an extended essay, “A Social History of American Railroads,” for the "), _c('em', [_vm._v("Encyclopedia of North American Railroads")]), _vm._v(", published by Indiana University Press in 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is impossible to acknowledge all of the individuals and institutions that have made this work possible. My long-standing connections with members of the Lexington Group in Transportation History, including Keith Bryant, Don Hofsommer, William Howes, Maury Klein, the late Albro Martin, the late Richard “Dick” Overton, Carlos Schwantes, the late John F. Stover, and James Ward, greatly enhanced my knowledge of railroading. Serving as editor of "), _c('em', [_vm._v("Railroad History")]), _vm._v(", the semiannual publication of the Railway & Locomotive Historical Society, for eleven years provided me with additional insights. During my tenure I considered a wide variety of submissions, including some that I would likely never have read under any other circumstance. And as the sources noted on the illustrations reveal, a number of individuals and institutions graciously assisted. I should also mention that during my academic career I have written more than twenty books on various aspects of the railroad enterprise, ranging from company histories to stations and technology. In the process literally scores of public and private research collections have been examined "), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _vm._v("and documentation assembled and individuals formally interviewed and informally consulted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I am grateful to the staff of Indiana University Press, especially Linda Oblack, sponsoring editor, to ensure that this study made its way into print. Finally, I would like to thank my wife, Martha Farrington Grant, for her assistance in preparing still another book manuscript. I am certain that she knows that the research and writing process will not end in the foreseeable future.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-335a713d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter01.vue
// module id = 78
// module chunks = 0